export enum AppScreen 
{
    Loading,
    Landing,
    GamesActivities,
    MeetTheCharacters,
    MatchingPairs,
    Quiz,
    SearchAndFind,
    ColourMe,
    ParentZone,
    ParentZoneIframe,
    EscalatorSafety,
}